var exports = {
  "B": "helpText__S4lXX3",
};

module.exports = exports;
